import "./navigator.ui.scss";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isNil, cloneDeep } from "lodash";

import { getNavPriv } from "./service";

// Const
import { PATH } from "router/config/const";
import { defaultModalStatus } from "./const";

// modal
import AddDeviceModal from "./modals/AddDeviceModal";

const Navigator = () => {
  const { t } = useTranslation();
  const pageContext = useSelector((state) => state.pageContext);
  const linkStatus = getNavPriv();

  // State
  const [modalStatus, setModalStatus] = useState(cloneDeep(defaultModalStatus));

  // Method
  const linkPriv = (data) => {
    if (!isNil(data.disabled) && data.disabled) {
      return null;
    }
    return data.to;
  };

  const changeModalStatus = (type, status) => {
    setModalStatus({ ...modalStatus, [type]: { ...modalStatus[type], status } });
  }

  useEffect(() => {
    // console.log("linkStatus, ", linkStatus);
  }, [pageContext]);

  return (
    <>

      <div className="navigator-container">
        <div id="navigator" className="layout-container">
          {
            // Dashboard
            linkStatus?.dashboard?.root?.show && (
              <Link to={linkStatus?.dashboard?.root?.link} className="first-item">
                {t("2938c7f7e5")}
              </Link>
            )
          }

          {
            // Monitor
            linkStatus?.monitor?.root?.show && (
              <div className="first-item">
                {t("6ba872551f")}
                <div className="first-child">
                  <div className="btn-child-link btn-first-child-link">
                    <div className="btn-first-child-link-content">
                      <div className="title">
                        {t("93f3450afb")}
                        <div className="second-child">
                          <Link
                            to="/configure/access-point/devices"
                            className="btn-child-link btn-real-link"
                          >
                            {t("c03ca67dda")}
                          </Link>
                          <Link
                            to="/configure/access-point/client"
                            className="btn-child-link btn-real-link"
                          >
                            {t("0f558243fb")}
                          </Link>
                          <Link
                            to="/configure/access-point/Event log"
                            className="btn-child-link btn-real-link"
                          >
                            {t("b59387e4d6")}
                          </Link>
                        </div>
                      </div>
                      <div className="icon icon-left-arrow"></div>
                    </div>
                  </div>
                  <div className="btn-child-link btn-first-child-link">
                    <div className="btn-first-child-link-content">
                      <div className="title">
                        {t("bbc155fb2b")}
                        <div className="second-child">
                          <Link
                            to="/configure/switch/devices"
                            className="btn-child-link btn-real-link"
                          >
                            {t("c03ca67dda")}
                          </Link>
                          <Link
                            to="/configure/switch/client"
                            className="btn-child-link btn-real-link"
                          >
                            {t("0f558243fb")}
                          </Link>
                          <Link
                            to="/configure/switch/Event log"
                            className="btn-child-link btn-real-link"
                          >
                            {t("b59387e4d6")}
                          </Link>
                        </div>
                      </div>
                      <div className="icon icon-left-arrow"></div>
                    </div>
                  </div>
                  <div className="btn-child-link btn-first-child-link">
                    <div className="btn-first-child-link-content">
                      <div className="title">
                        {t("926dec9494")}
                        <div className="second-child">
                          <Link
                            to="/configure/gateway/devices"
                            className="btn-child-link btn-real-link"
                          >
                            {t("c03ca67dda")}
                          </Link>
                          <Link
                            to="/configure/gateway/client"
                            className="btn-child-link btn-real-link"
                          >
                            {t("0f558243fb")}
                          </Link>
                          <Link
                            to="/configure/gateway/Event log"
                            className="btn-child-link btn-real-link"
                          >
                            {t("b59387e4d6")}
                          </Link>
                        </div>
                      </div>
                      <div className="icon icon-left-arrow"></div>
                    </div>
                  </div>
                  <Link
                    to="/monitor/map"
                    className="btn-child-link btn-real-link"
                  >
                    {t("46f3ea056c")}
                  </Link>
                  <Link
                    to="/monitor/floor-plans"
                    className="btn-child-link btn-real-link"
                  >
                    {t("52600791cd")}
                  </Link>
                  <Link
                    to="/monitor/neighbor-ap"
                    className="btn-child-link btn-real-link"
                  >
                    {t("4c8ac262ab")}
                  </Link>
                </div>
              </div>
            )
          }

          {
            // Configure
            linkStatus?.configure?.root?.show && (
              <div className="first-item">
                {t("f1206f9fad")}
                <div className="first-child">
                  <div className="btn-child-link btn-first-child-link">
                    <div className="btn-first-child-link-content">
                      <div className="title">
                        {t("93f3450afb")}
                        <div className="second-child">
                          <Link
                            to="/configure/access-point/profiles"
                            className="btn-child-link btn-real-link"
                          >
                            {t("d0f2511528")}
                          </Link>
                          <Link
                            to="/configure/access-point/devices"
                            className="btn-child-link btn-real-link"
                          >
                            {t("c03ca67dda")}
                          </Link>
                          <Link
                            to="/configure/access-point/ip-acls"
                            className="btn-child-link btn-real-link"
                          >
                            {t("b3cb751d2f")}
                          </Link>
                        </div>
                      </div>
                      <div className="icon icon-left-arrow"></div>
                    </div>
                  </div>
                  <div className="btn-child-link btn-first-child-link">
                    <div className="btn-first-child-link-content">
                      <div className="title">
                        {t("bbc155fb2b")}
                        <div className="second-child">
                          <Link
                            to="/configure/switch/profiles"
                            className="btn-child-link btn-real-link"
                          >
                            {t("d0f2511528")}
                          </Link>
                          <Link
                            to="/configure/switch/devices"
                            className="btn-child-link btn-real-link"
                          >
                            {t("c03ca67dda")}
                          </Link>
                          <Link
                            to="/configure/switch/switch-port"
                            className="btn-child-link btn-real-link"
                          >
                            {t("e8b79e0992")}
                          </Link>
                        </div>
                      </div>
                      <div className="icon icon-left-arrow"></div>
                    </div>
                  </div>
                  <div className="btn-child-link btn-first-child-link">
                    <div className="btn-first-child-link-content">
                      <div className="title">
                        {t("926dec9494")}
                        <div className="second-child">
                          <Link
                            to="/configure/gateway/profiles"
                            className="btn-child-link btn-real-link"
                          >
                            {t("d0f2511528")}
                          </Link>
                          <Link
                            to="/configure/gateway/devices"
                            className="btn-child-link btn-real-link"
                          >
                            {t("c03ca67dda")}
                          </Link>
                        </div>
                      </div>
                      <div className="icon icon-left-arrow"></div>
                    </div>
                  </div>
                  <div className="btn-child-link btn-first-child-link">
                    <div className="btn-first-child-link-content">
                      <div className="title">
                        {t("6963479edc")}
                        <div className="second-child">
                          <Link
                            to="/configure/authenication-servers"
                            className="btn-child-link btn-real-link"
                          >
                            {t("9590cf7c18")}
                          </Link>
                          <Link
                            to="/configure/local-authenication-list"
                            className="btn-child-link btn-real-link"
                          >
                            {t("2680c6cd03")}
                          </Link>
                        </div>
                      </div>
                      <div className="icon icon-left-arrow"></div>
                    </div>
                  </div>
                  <Link
                    to="/configure/mac-acls"
                    className="btn-child-link btn-real-link"
                  >
                    {t("0d882c46fa")}
                  </Link>
                  <Link
                    to="/configure/walled-garden"
                    className="btn-child-link btn-real-link"
                  >
                    {t("bf56b84e69")}
                  </Link>
                  <Link
                    to="/configure/schedule-policies"
                    className="btn-child-link btn-real-link"
                  >
                    {t("aae6b7bf48")}
                  </Link>
                  <Link
                    to="/configure/splash-pages"
                    className="btn-child-link btn-real-link"
                  >
                    {t("7d664876bc")}
                  </Link>
                </div>
              </div>
            )
          }

          {
            // Report
            linkStatus?.reports?.root?.show && (
              <div className="first-item">
                {t("c91c7b93c2")}
                <div className="first-child">
                  {linkStatus?.reports?.changeLog?.show && (
                    <Link
                      to={PATH.reports.change_log}
                      className="btn-child-link btn-real-link"
                    >
                      {t("6174d88cc7")}
                    </Link>
                  )}
                  {linkStatus?.reports?.summary?.show && (
                    <Link
                      to={PATH.reports.summary_report}
                      className="btn-child-link btn-real-link"
                    >
                      {t("d37ef8b077")}
                    </Link>
                  )}
                  {linkStatus?.reports?.alerts?.show && (
                    <Link
                      to={PATH.reports.alerts}
                      className="btn-child-link btn-real-link"
                    >
                      {t("df583ae7ba")}
                    </Link>
                  )}
                  {linkStatus?.reports?.licenses?.show && (
                    <Link
                      to={PATH.reports.licenses}
                      className="btn-child-link btn-real-link"
                    >
                      {t("f6aca2dcfe")}
                    </Link>
                  )}
                </div>
              </div>
            )
          }

          {
            // Setting
            linkStatus?.settings?.root?.show && (
              <div className="first-item">
                {t("6525f0afe7")}
                <div className="first-child ">
                  {linkStatus?.settings?.account?.show && (
                    <Link
                      to={PATH.settings.account}
                      className="btn-child-link btn-real-link"
                    >
                      {t("09f0c5159c")}
                    </Link>
                  )}
                  {linkStatus?.settings?.org?.show && (
                    <Link
                      to={PATH.settings.organization}
                      className="btn-child-link btn-real-link"
                    >
                      {t(linkStatus?.settings?.org?.name)}
                    </Link>
                  )}
                  {linkStatus?.settings?.license?.show && (
                    <Link
                      to={PATH.settings.license_management}
                      state={{ tab: 'overview' }}
                      className="btn-child-link btn-real-link"
                    >
                      {t("40be8113d7")}
                    </Link>
                  )}
                  {linkStatus?.settings?.inventory?.show && (
                    <Link
                      to={PATH.settings.license_management}
                      state={{ tab: 'devices' }}
                      className="btn-child-link btn-real-link"
                    >
                      {t("4d604dd8f0")}
                    </Link>
                  )}
                  {linkStatus?.settings?.firmware?.show && (
                    <Link
                      to="/settings/firmware"
                      className="btn-child-link btn-real-link"
                    >
                      {t("a940a548ba")}
                    </Link>
                  )}
                  {linkStatus?.settings?.alert?.show && (
                    <Link
                      to="/settings/alert-settings"
                      className="btn-child-link btn-real-link"
                    >
                      {t("5cfe7a6558")}
                    </Link>
                  )}
                  {linkStatus?.settings?.certificate?.show && (
                    <Link
                      to="/settings/certificate-management"
                      className="btn-child-link btn-real-link"
                    >
                      {t("41a3a2d0d1")}
                    </Link>
                  )}
                  {linkStatus?.settings?.externalAlert?.show && (
                    <Link
                      to="/settings/external-email-alert-settings"
                      className="btn-child-link btn-real-link"
                    >
                      {t("561a6e6b06")}
                    </Link>
                  )}
                  {linkStatus?.settings?.advanced?.show && (
                    <div className="btn-child-link btn-first-child-link">
                      <div className="btn-first-child-link-content">
                        <div className="title">
                          {t("a6e7cd29c1")}
                          <div className="second-child left-side">
                            {linkStatus?.settings?.advanced?.links?.map(
                              (item, index) => {
                                return (
                                  <Link
                                    key={"nav_settings_advanced_" + index}
                                    to={linkPriv(item)}
                                    className="btn-child-link btn-real-link"
                                    disabled={item.disabled}
                                  >
                                    {t(item.label)}
                                  </Link>
                                );
                              }
                            )}
                          </div>
                        </div>
                        <div className="icon icon-left-arrow"></div>
                      </div>
                    </div>
                  )}
                  {linkStatus?.settings?.addDevice?.show && (
                    <div
                      className="btn-child-link btn-first-child-link"
                      disabled={linkStatus?.settings?.addDevice?.disabled}
                      onClick={() => changeModalStatus(modalStatus.addDevice.type, true)}
                    >
                      {t("5290e89436")}
                    </div>
                  )}
                  {linkStatus?.settings?.bulkDevice?.show && (
                    <Link
                      to={linkPriv(linkStatus?.settings?.bulkDevice)}
                      className="btn-child-link btn-real-link"
                      disabled={linkStatus?.settings?.bulkDevice?.disabled}
                    >
                      {t("de8f8e95a9")}
                    </Link>
                  )}
                  {linkStatus?.settings?.bulkConfig?.show && (
                    <div className="btn-child-link btn-first-child-link">
                      <div className="btn-first-child-link-content">
                        <div className="title">
                          {t("ada806c830")}
                          <div className="second-child left-side">
                            {linkStatus?.settings?.bulkConfig?.links?.map(
                              (item, index) => {
                                return (
                                  <Link
                                    key={"nav_settings_bulkConfig_" + index}
                                    to={linkPriv(item)}
                                    className="btn-child-link btn-real-link"
                                    disabled={item.disabled}
                                  >
                                    {t(item.label)}
                                  </Link>
                                );
                              }
                            )}
                          </div>
                        </div>
                        <div className="icon icon-left-arrow"></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          }

          {
            // Help
            linkStatus?.help?.root?.show && (
              <div className="first-item">
                {t("6a26f54883")}
                <div className="first-child left-side">
                  <Link
                    to={PATH.help.announcements}
                    className="btn-child-link btn-real-link"
                  >
                    {t("1bd0ebd0ec")}
                  </Link>
                  {linkStatus?.help?.technicalSupport?.show && (
                    <Link
                      to="/help/contact-technical-support"
                      className="btn-child-link btn-real-link"
                    >
                      {t("9cfc9b7498")}
                    </Link>
                  )}
                  {linkStatus?.help?.resources?.show && (
                    <div className="btn-child-link btn-first-child-link">
                      {t("e770a517f0")}
                    </div>
                  )}
                  {linkStatus?.help?.troubleshooting?.show && (
                    <Link
                      to="/help/troubleshooting"
                      className="btn-child-link btn-real-link"
                    >
                      {t("231cf4c70d")}
                    </Link>
                  )}
                  {linkStatus?.help?.tutorials?.show && (
                    <div className="btn-child-link btn-first-child-link">
                      {t("c36fc19002")}
                    </div>
                  )}
                </div>
              </div>
            )
          }
        </div>
      </div>

      <AddDeviceModal
        modalStatus={modalStatus}
        changeModalStatus={changeModalStatus}
      />
    </>
  );
};

export default Navigator;
